
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 5.667A2.833 2.833 0 115.667 8.5 2.837 2.837 0 018.5 5.667zm0-1.889A4.722 4.722 0 1013.222 8.5 4.722 4.722 0 008.5 3.778zm0-1.889a6.635 6.635 0 01.944.076V0H7.556v1.964a6.635 6.635 0 01.944-.075zM4.548 3.212l-1.39-1.391-1.335 1.336 1.391 1.391a6.6 6.6 0 011.334-1.336zm9.239 1.335l1.391-1.391-1.335-1.335-1.391 1.391a6.652 6.652 0 011.335 1.335zM8.5 15.111a6.636 6.636 0 01-.944-.076V17h1.889v-1.964a6.635 6.635 0 01-.945.075zm3.952-1.324l1.391 1.391 1.336-1.336-1.391-1.39a6.706 6.706 0 01-1.336 1.335zM1.889 8.5a6.635 6.635 0 01.076-.944H0v1.889h1.964a6.635 6.635 0 01-.075-.945zm13.147-.944a5.941 5.941 0 010 1.889H17V7.556zm-11.823 4.9l-1.392 1.387 1.335 1.335 1.391-1.391a6.652 6.652 0 01-1.335-1.335z","fill":"#fff"}})])
          )
        }
      }
    